import { useRollbar } from "@rollbar/react";

export const useSyncRequest = () => {
	const rollbar = useRollbar();

	function syncRequest(dados: string[], attempts = 0) {
		// Sync request removido - socket/dados não é mais usado no sistema
		console.log("Sync request removido - funcionalidade não é mais usada", dados);
		rollbar.log("Sync request chamado mas removido - funcionalidade não é mais usada");
	}

	return { syncRequest };
};
